import { render, staticRenderFns } from "./IngresoMultasSelectNuevo.vue?vue&type=template&id=13be3add&"
import script from "./IngresoMultasSelectNuevo.vue?vue&type=script&lang=js&"
export * from "./IngresoMultasSelectNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports